import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/contact/sync/many/user.contact.sync.many.mutation.gql"
import type {
  UserContactSyncManyMutation,
  UserContactSyncManyMutationVariables,
} from "@/v2-backoffice-client/user/contact/sync/many/__types__/user.contact.sync.many.mutation"

type Options = MutationHookOptions<
  UserContactSyncManyMutation,
  UserContactSyncManyMutationVariables
>

// Each result carries the full updated user (normalized-cache refresh of
// Contact + ContactSyncStatus everywhere) plus a per-user Error when that
// user's sync failed — the mutation itself only errors batch-wide.
export function useUserContactSyncManyMutation(options?: Options) {
  return useMutation<
    UserContactSyncManyMutation,
    UserContactSyncManyMutationVariables
  >(mutation, options)
}
